import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function WorkOrderStackFeatures() {
  const benefits = [
    {
      img: img1,
      title: "Create and View Work Orders ",
      bodycopy: "Easily generate new work orders and access detailed information about each work order."    },
    {
      img: img2,
      title: "Track Work Order Status",
      bodycopy: "Monitor the progress of work orders in real-time, ensuring smooth operations.",
    },
    {
      img: img3,
      title: "Update Work Order Status",
      bodycopy:
        "Keep all stakeholders informed by updating the status of work orders as they progress through different stages.",
    },
    {
        img: img3,
        title: "View Current Work Order Status",
        bodycopy:
          "Quickly view the latest status of any work order at any given time. ",
      },
      {
        img: img3,
        title: "Track Work Order History",
        bodycopy:
          "Access the entire history and timeline of the work order status changes for audit and performance tracking.",
      },

      {
        img: img3,
        title: "Assign Work Orders to Farming Sites",
        bodycopy:
          "Allocate specific work orders to designated farming locations, ensuring proper assignment and execution.",
      },
      {
        img: img3,
        title: " List of All Work Orders",
        bodycopy:
          "View a comprehensive list of all work orders, organized for easy management and tracking.",
      },


      // {
      //   img: img3,
      //   title: " Create and View Work Orders",
      //   bodycopy:
      //     "Easily generate new work orders and access detailed information for each manufacturing project.",
      // },
      // {
      //   img: img3,
      //   title: " Track Work Order Status",
      //   bodycopy:
      //     "Monitor the progress of each work order in real-time, ensuring manufacturing processes stay on schedule.",
      // },
      // {
      //   img: img3,
      //   title: " Update Work Order Status",
      //   bodycopy:
      //     "Keep all relevant stakeholders updated by modifying the status as the work order progresses through different stages of production.",
      // },
      {
        img: img3,
        title: " Assign Work Orders to Production Units",
        bodycopy:
          "Allocate specific work orders to appropriate production units or facilities, ensuring efficient execution.",
      },
      {
        img: img3,
        title: " Manage Raw Materials and Inventory for Work Orders",
        bodycopy:
          "Track raw materials and inventory usage for each work order to optimize resource allocation and reduce waste.",
      },
      {
        img: img3,
        title: " Quality Control and Inspection for Work Orders",
        bodycopy:
          "Integrate quality assurance checks at different stages to ensure that manufacturing outputs meet required standards.",
      },

      {
        img: img3,
        title: " Track Production Time and Costs",
        bodycopy:
          "Monitor the labor, time, and cost involved in each work order to ensure production efficiency and budget management.",
      },
      // {
      //   img: img3,
      //   title: " List of All Work Orders",
      //   bodycopy:
      //     "Access and manage a comprehensive list of all work orders, enabling easy tracking and visibility of production workflows.",
      // },

  ];
  return (
    <div className="main-wrapper">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Features
      </h2>
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col md={4} key={index} className="d-flex">
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
